<div class="widget-payment-methods-container">
    <h4 class="widget-payment-methods__title">
        {{ "footer.pagamentosicuro" | T }}
    </h4>
    <div class="widget-payment-methods-content">
        <div class="icons-wrapper">
            @for(method of paymentMethods; track method.id){
                <div class="payment-methods-icon-wrapper">
                    <img
                        [src]="method.img"
                        [alt]="method.name"
                        class="payment-logo img-fluid"
                        loading="lazy"
                    />
                </div>
            }
        </div>
    </div>
</div>
